import { Outlet } from 'react-router-dom';
import styled from 'styled-components';

const StyledLayout = styled.div`
  width: 100%;
  height: 100vh;
  display: flex;
  flex-flow: column nowrap;
  z-index: 110;
  background-color: transparent;
`;

export const EmbedLayout = () => {
  return (
    <StyledLayout>
      <Outlet />
    </StyledLayout>
  );
};
